import * as React from 'react';
import '../index.css';
import {
  white1, white2, white3, black1, black2, black3,
  grey1, grey2, grey3, grey4, grey5, grey6, grey7, grey8, grey9,
  red1, red2, red3, red4, red5
} from '@riiid/santa-closet-web';
import {dark, light} from '@riiid/santa-closet-web/theme';
import withStyles from 'react-jss'
import Highlight from 'react-highlight';

const styles = {
  wrap: {
    display: 'inline-block',
    width: '100%'
  },
  content: {
    display: 'inline-block',
    margin: {
      bottom: 20
    }
  },
  card: {
    display: 'flex',
    flexDirection:'column',
    float: 'left',
    maxWidth: 80,
    fontSize: 14,
    margin: 5,
    boxShadow: '4px 4px 12px rgba(0, 0, 0, 0.12)',
    '& p': {
      padding: 5,
      margin: 0
    }
  }
};

const ColorCard = ({classes, fill, text}) => {
  return (
    <div className={classes.card}>
      <svg width={80} height={50} viewBox="0 0 80 50" fill={fill}>
        <rect x="0" y="0" width="80" height="50" fill={fill}/>
      </svg>
      <p>{text}</p>
      <p>{fill}</p>
    </div>
  )
};

const StyledCard = withStyles(styles)(ColorCard);

const SantaColor = ({classes}) => {
  return (
    [
      <div className={classes.wrap} key="black">
        <h3>black & white</h3>
        <StyledCard fill={black1} text="black1"/>
        <StyledCard fill={black2} text="black2"/>
        <StyledCard fill={black3} text="black3"/>
        <StyledCard fill={white1} text="white1"/>
        <StyledCard fill={white2} text="white2"/>
        <StyledCard fill={white3} text="white3"/>
      </div>,
      <div className={classes.wrap} key="grey">
        <h3>grey</h3>,
        <StyledCard fill={grey1} text="grey1"/>
        <StyledCard fill={grey2} text="grey2"/>
        <StyledCard fill={grey3} text="grey3"/>
        <StyledCard fill={grey4} text="grey4"/>
        <StyledCard fill={grey5} text="grey5"/>
        <StyledCard fill={grey6} text="grey6"/>
        <StyledCard fill={grey7} text="grey7"/>
        <StyledCard fill={grey8} text="grey8"/>
        <StyledCard fill={grey9} text="grey9"/>
      </div>,
      <div className={classes.wrap} key="red">
        <h3>red</h3>
        <StyledCard fill={red1} text="red1"/>
        <StyledCard fill={red2} text="red2"/>
        <StyledCard fill={red3} text="red3"/>
        <StyledCard fill={red4} text="red4"/>
        <StyledCard fill={red5} text="red5"/>
      </div>,
      <Highlight language="javascript" className="code-block" key="code">
        {`import {red1} from '@riiid/santa-closet-web';

  export class Example extends Component {
    render () {
      return <h1 style={{color: red1}}>Hello, Santa</h1>
    }
  }`}
      </Highlight>
    ]
  )
};

const DarkColor = ({classes}) => {
  return (
    <div className={classes.wrap}>
      <h3 className={classes.title}>dark</h3>
      <div className={classes.content}>{
        Object.keys(dark)
          .filter(color => color.indexOf('color') > -1)
          .map((color,i) => {
            return <StyledCard fill={dark[color]} text={color} key={i}/>
          })
      }
      </div>
      <Highlight language="javascript" className="code-block">
        {`import {dark} from '@riiid/santa-closet-web/theme';

  export class Example extends Component {
    render () {
      return <h1 style={{color: dark.color1}}>Hello, Santa</h1>
    }
  }`}
      </Highlight>
      </div>
  )
};

const LightColor = ({classes}) => {
  return (
    <div className={classes.wrap}>
      <h3 className={classes.title}>light</h3>
      <div className={classes.content}>{
        Object.keys(light)
          .filter(color => color.indexOf('color') > -1)
          .map((color,i) => {
            return <StyledCard fill={light[color]} text={color} key={i}/>
          })
      }
      </div>
      <Highlight language="javascript" className="code-block">
        {`import {light} from '@riiid/santa-closet-web/theme';

  export class Example extends Component {
    render () {
      return <h1 style={{color: light.color1}}>Hello, Santa</h1>
    }
  }`}
      </Highlight>
    </div>
  )
};

export default class Colors extends React.Component {
  _renderTypeColor = type => {
    switch (type) {
      case "dark":
        const StyledDarkColor = withStyles(styles)(DarkColor);
        return <StyledDarkColor/>;
      case "light":
        const StyledLightColor = withStyles(styles)(LightColor);
        return <StyledLightColor/>;
      default:
        const StyledSantaColor = withStyles(styles)(SantaColor);
        return <StyledSantaColor/>
    }
  };
  render() {
    const {theme} = this.props;
    return (
      this._renderTypeColor(theme)
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Colors.js